import { render, staticRenderFns } from "./SystemTagsCreationControl.vue?vue&type=template&id=3895de3c"
import script from "./SystemTagsCreationControl.vue?vue&type=script&lang=ts"
export * from "./SystemTagsCreationControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports